<template>
<div>
	<h1>Error 404</h1>
	<h2 v-if="heading">{{heading}}</h2>
	<slot></slot>
</div>
</template>

<script>
export default {
	name: "error-404",
	props:
	{
		'heading' : { type : String, default : "Element or Path Not Found" }
	}
};
</script>


// WEBPACK FOOTER //
// src/components/Error404.vue